import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

interface DatePickerWrapperProps {
  hasError: boolean,
  nbPerLine: number,
  noBottomPadding?: boolean
}

export const DatePickerWrapper = styled.div<DatePickerWrapperProps>`
  flex-basis: calc(${(props) => 100 / props.nbPerLine}% - ${(props) => 5 * (props.nbPerLine - 1)}px);
  
  ${(props) => !props.noBottomPadding && `
    padding-bottom: 17px;
  `};
  
  ${(props) => props.hasError && `
    & .ant-picker-input {
      border-color: ${colors.reddishPink};
    }
  `};
  
  @media (max-width: ${measures.mobileThreshold}px) {
    flex-basis: 100%;
    padding-right: 0;
  }
  
  & div.ant-picker {
    width: 100%;
    padding: 8px 12px;
  }
`

export const SuffixIcon = styled.img`
  width: 10px;
  height: 10px;
`

export const BasicIcon = styled.span`
  &.anticon {
    color: ${colors.waterBlue};
    font-size: 16px;
  }
`

export const DatePickerLabel = styled.div`
  line-height: 19px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 11px;
`

export const Required = styled.span `
  color: ${colors.waterBlue};
`
